import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-trash\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M6.444 0h11.112H6.444zM22 6v13.2c0 2.651-1.99 4.8-4.444 4.8H6.444C3.99 24 2 21.851 2 19.2V6h2v13.5C4 20.88 5.03 22 6.3 22h11.505c1.27 0 2.3-1.12 2.3-2.5V6H22z\" fill-rule=\"nonzero\" /><rect y=\"4\" width=\"24\" height=\"2\" rx=\"1\" /><path d=\"M15.299 2H8.7l-.777 2h8.152L15.3 2zM8.7 0H15.3a2 2 0 0 1 1.864 1.275L19 6H5l1.837-4.725A2 2 0 0 1 8.701 0z\" fill-rule=\"nonzero\" /><rect x=\"6\" y=\"8\" width=\"2\" height=\"12\" rx=\"1\" /><rect x=\"11\" y=\"8\" width=\"2\" height=\"12\" rx=\"1\" /><rect x=\"16\" y=\"8\" width=\"2\" height=\"12\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-trash.svg
// module id = 893
// module chunks = 74